import CitySEOHead from "@/components/feature/CitySEOHead";
import HammondHeroSection from "./components/HeroSection";
import HammondStickyNav from "./components/StickyNav";
import HammondProcessingTimeSection from "./components/ProcessingTimeSection";
import HammondServicesSection from "./components/ServicesSection";
import HammondLocalAreaSection from "./components/LocalAreaSection";
import HammondTestimonialsSection from "./components/TestimonialsSection";
import HammondAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HammondComparisonSection from "./components/ComparisonSection";
import HammondMistakesSection from "./components/MistakesSection";
import HammondHowItWorksSection from "./components/HowItWorksSection";
import HammondFAQSection, { faqs } from "./components/FAQSection";
import HammondHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HammondFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import HammondTravelTimingSection from "./components/TravelTimingSection";
import HammondDestinationsSection from "./components/DestinationsSection";

export default function HammondPage() {
  return (
    <>
      <CitySEOHead
        city="Hammond"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/hammond"
        title="Emergency Passport Hammond, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Hammond, LA — as fast as 24 hours. Serving SLU students, agricultural exporters, and Tangipahoa Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Hammond, Louisiana"
        geoPosition="30.5044;-90.4612"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <div className="font-sans">
        <HammondHeroSection />
        <HammondStickyNav />
        <HammondProcessingTimeSection />
        <HammondServicesSection />
        <HammondLocalAreaSection />
        <HammondTravelTimingSection />
        <HammondDestinationsSection />
        <HammondTestimonialsSection />
        <HammondAcceptanceFacilitiesSection />
        <HammondComparisonSection />
        <HammondMistakesSection />
        <HammondHowItWorksSection />
        <HammondFAQSection />
        <HammondHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/hammond" state="LA" />
        <HammondFinalCTA />
      </div>
    </>
  );
}